export default __webpack_public_path__ + "static/media/sr-3m.70b35d21.svg";